var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDineroMonedas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 54.814,
    viewBox: "0 0 64 54.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_680",
    "data-name": "Grupo 680",
    transform: "translate(-902.02 -2384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2815",
    "data-name": "Trazado 2815",
    d: "M817.557,24.631h-.215a10.767,10.767,0,1,0-12.685,12.685v.215A12.922,12.922,0,1,0,817.578,24.61ZM805.432,33.1a6.457,6.457,0,1,1,7.667-7.667A12.965,12.965,0,0,0,805.432,33.1Zm12.125,13.073a8.615,8.615,0,1,1,8.615-8.615A8.612,8.612,0,0,1,817.557,46.168Z",
    transform: "translate(135.52 2388.361)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2816",
    "data-name": "Trazado 2816",
    d: "M793.247,8.005c-5.1,0-9.227,3.855-9.227,8.615V38.156h20.761a2.159,2.159,0,1,0,0-4.307h-6.921c0-4.76-4.129-8.615-9.227-8.615V20.927c5.1,0,9.227-3.855,9.227-8.615h27.682c0,4.76,4.129,8.615,9.227,8.615v2.154a2.312,2.312,0,0,0,4.614,0V8.005Zm0,25.844h-4.614V29.542A4.482,4.482,0,0,1,793.247,33.849ZM788.634,16.62a4.482,4.482,0,0,1,4.614-4.307A4.482,4.482,0,0,1,788.634,16.62Zm46.136,0a4.482,4.482,0,0,1-4.614-4.307h4.614Z",
    transform: "translate(118 2375.995)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2817",
    "data-name": "Trazado 2817",
    d: "M799.481,12.017a6.45,6.45,0,0,0-5.6,9.67,2.142,2.142,0,0,0,1.874,1.077,2.149,2.149,0,0,0,1.874-3.231,2.062,2.062,0,0,1-.28-1.077,2.159,2.159,0,0,1,4.027-1.077,2.146,2.146,0,0,0,3.726-2.132A6.469,6.469,0,0,0,799.5,12Z",
    transform: "translate(129.869 2381.26)",
    fill: "#00c1d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineroMonedas);
export default __webpack_public_path__ + "static/media/dinero-monedas.a50ee672d89ba304bd08bc825e70cb72.svg";
export { ForwardRef as ReactComponent };